<template>
    <field-template :required="required" :errors="errors" :name="name" :label="label">
        <template v-slot:field>
            <select
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                v-model="content"
                class="block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-uknar-primary focus:border-uknar-primary sm:text-sm">
                <option value = "">Please select...</option>
                <option v-for="option of options"
                        :value="option[optionValue]">{{ option[optionLabel] }}</option>
            </select>
        </template>
    </field-template>

</template>

<script>
export default {
    name: 'SelectField',
    emits: ['update:modelValue'],
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean
        },
        errors: {
            type: Array
        },
        modelValue: {
            default: '',
        },
        options: {
            type: Array,
            required: true
        },
        optionLabel: {
            type: String,
            default: 'label'
        },
        optionValue: {
            type: String,
            default: 'value'
        }
    },
    data () {
        return {
            content: this.value
        }
    }
}
</script>
